import { AfterViewInit, Directive, ElementRef } from '@angular/core';

import { SvgDirectiveBase } from '../../baseBtl/base/directives/svg.directive';
import { BASEURL } from '../classes/btl-constants';

@Directive({ selector: '[btlSvg]' })
export class SvgDirective extends SvgDirectiveBase implements AfterViewInit {
    protected sufixUrl: string = BASEURL;

    constructor(protected el: ElementRef) {
        super(el);
    }
}
